module.exports = __webpack_public_path__ + "static/media/project-02.ba6b0d76.gif";